import { Component, input } from '@angular/core';
import {
  NotificationLayoutComponent
} from '../../notification-detail-layout/notification-detail-layout.component';
import { environment } from '../../../../environments/environment';
import { NotificationStep } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-completed-unit-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="Hooray! Your student(s) completed an instructional unit 🎉"
      [preambles]="[{
        text: 'It’s time to celebrate! The following student(s) finished an instructional unit today — '
          + 'that means they powered through 19–23 tasks and took a real step toward fluency. 💪'
        }]"
      [steps]="steps"
      ctaLabel="Open Unit Detail report"
      ctaRoute="/reports/system/unit-detail"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Date</th>
          <th class="th">Unit</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td" style="white-space:nowrap; color:#a2a2a2;">{{ notification.data.displaydate }}</td>
            <td class="td"><span class="badge-green">{{ notification.data.unitcompleted }}</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true,
})
export class CompletedUnitNotificationComponent {
  private readonly studentAppLink = environment.studentSiteURL;
  readonly data = input.required<any>();
  readonly steps: NotificationStep[] = [
    {
      title: 'Review the Unit Detail report',
      body: 'Open the Unit Detail report, select the student from the dropdown, and sort by % correct or time to spot strengths and tasks worth revisiting.'
    },
    {
      title: 'Review their responses in the Unit Detail report',
      body: 'Open the Unit Detail report, select the student, then click the + next to the task to see exactly how they responded to each trial.'
    },
    {
      title: 'Try the task together',
      body: 'Log in to the <a href="' + this.studentAppLink + '" target="_blank">student demo program</a> and work through a challenging task side-by-side. '
        + 'Use the Unit Detail report to find the Unit, Level, and Word List &mdash; and check the Group Summary report for their Instructional Zone if needed.'
    },
    {
      title: 'Celebrate with your student! 🙌',
      body: 'They worked hard to get here — a high five, a shoutout, a sticker — whatever fits your classroom. It matters more than you know.',
      variant: 'green',
    }
  ];
}
